<template>
  <!-- 头部整体盒子 -->
  <div id="header" class="container-fuild">
    <!-- 头部顶部 -->
    <!-- <div class="header-top container-fuild hidden-xs">
      <div class="container">
        <div class="server pull-left">
          <span class="glyphicon glyphicon-earphone"></span>888-888-888
          <span class="glyphicon glyphicon-envelope"></span>xxx@163.com
          <span class="glyphicon glyphicon-time"></span>7x24小时为您服务
        </div>
        <div class="shejiao pull-right">
          <span class="glyphicon glyphicon-hand-right"></span>赶快联系我们吧！
          <span class="glyphicon glyphicon-hand-left"></span>
        </div>
      </div>
    </div> -->
    <!-- 电脑导航 -->
    <div class="header-nav container hidden-xs">
      <!-- 导航logo -->
      <div class="header-nav-logo">
        <router-link :to="'/'">
          <img src="@/assets/img/qilin_logo.png" @click="toHome">
        </router-link>
      </div>
      <!-- 导航内容 -->
      <ul class="header-nav-wrapper" :key="rfresh">
        <li v-for="(item, index) in navList" :key="index" :class="index == navIndex ? 'active' : ''"
          @click="navClick(index, item.name)">
          <router-link :to="item.path">
            {{ item.name }}
            <span v-if="item.children.length > 0" class="glyphicon glyphicon-chevron-up"></span>
            <i class="underline"></i>
          </router-link>
          <dl v-if="item.children.length > 0">
            <dt v-for="(i, n) in item.children" :key="n">
              <router-link :to="i.path">{{ i.name }}</router-link>
            </dt>
          </dl>
        </li>
      </ul>
      <!-- 主题切换按钮 -->
      <div class="header-theme-toggle">
        <ThemeToggle />
      </div>
    </div>
    <!-- 手机导航 -->
    <div class="header-nav-m container-fuild visible-xs">
      <div style="display: flex; justify-content: space-between; align-items: center; padding: 0 30px;">
        <div class="header-nav-m-logo">
          <router-link :to="'/'">
            <img class="center-block" src="@/assets/img/qilin_logo.png" alt="logo" @click="toHome">
          </router-link>
        </div>
        <div class="header-nav-m-right">
          <ThemeToggle />
          <div data-toggle="collapse" data-target="#menu" @click="menuClick" style="margin-left: 15px;">
            <span :class="menuClass"></span>
          </div>
        </div>
      </div>
      <!-- 导航栏 -->
      <div class="header-nav-m-menu text-center">
        <!-- 导航内容 -->
        <ul id="menu" class="header-nav-m-wrapper collapse">
          <li v-for="(item, index) in navList" :key="index" :class="index == navIndex ? 'active' : ''"
            @click="navClick(index, item.name)" data-toggle="collapse" data-target="#menu">
            <router-link :to="item.path">
              {{ item.name }}
              <i class="underline"></i>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import {
  mapState
} from "vuex"
import ThemeToggle from './ThemeToggle.vue'
export default {
  name: "Header",
  components: {
    ThemeToggle
  },
  data() {
    return {
      navIndex: sessionStorage.getItem('navIndex') ? sessionStorage.getItem('navIndex') : 0,
      menuClass: "glyphicon glyphicon-align-justify",
      rfresh: -1,
      navList: [
        {
          name: "首页",
          path: "/",
          children: []
        },
        {
          name: "组学服务",
          path: "/service",
          children: []
        },
        {
          name: "分子实验",
          path: "/molecularexperiments",
          children: []
        },
        {
          name: "生信服务",
          path: "/perkhidmatanbio-maklumat",
          children: []
        },
        {
          name: "关于我们",
          path: "/companyintroduction",
          children: []
        },
        // {
        //   name: "行业动态",
        //   path: "/newsinformation",
        //   children: []
        // },
        {
          name: "联系我们",
          path: "",
          children: []
        },
      ]
    };
  },
  computed: {
    ...mapState(['navName']),
  },
  watch: {
    navName(newVal, oldVal) {
      this.changeNav(newVal)
    }
  },
  mounted() {
    // 初始化导航栏样式
    this.initHeaderStyle();
    // 监听滚动事件
    window.addEventListener('scroll', this.onScroll);
  },
  destroyed() {
    // 移除滚动事件监听
    window.removeEventListener('scroll', this.onScroll);
  },
  methods: {
    // 初始化导航栏样式
    initHeaderStyle() {
      var contentElement = document.getElementById('header');
      contentElement.style.position = 'sticky';
      contentElement.style.top = '0';
      contentElement.style.zIndex = '1000';
      contentElement.style.left = '0';
      contentElement.style.right = '0';
      contentElement.style.background = 'var(--bg-primary)';
      contentElement.style.boxShadow = 'var(--shadow-sm)';
    },
    // 滚动事件处理
    onScroll() {
      var contentElement = document.getElementById('header');
      contentElement.style.background = 'var(--bg-primary)';
      contentElement.style.boxShadow = 'var(--shadow-sm)';
    },
    changeNav(name) {
      this.navIndex = this.navList.findIndex((x) => x.name == name);
      sessionStorage.setItem('navIndex', this.navIndex)
      this.$emit('toTop')
      this.rfresh = Math.random()
    },
    toHome() {
      this.navIndex = 0;
      sessionStorage.setItem('navIndex', 0)
      this.$emit('toTop')
    },
    navClick(index, name) {
       this.menuClick()
        this.navIndex = index;
        sessionStorage.setItem('navIndex', index)
      if (name == '联系我们') {
        this.$emit('toBottom')
      } else {
        this.$emit('toTop')
      }
    },
    menuClick() {
      if (this.menuClass == "glyphicon glyphicon-align-justify") {
        this.menuClass = "glyphicon glyphicon-remove";
      } else {
        this.menuClass = "glyphicon glyphicon-align-justify";
      }
    }
  }
};
</script>
<style scoped>
/* 顶部 */
#header {
  background: var(--bg-primary);
  box-shadow: var(--shadow-sm);
  transition: all ease 0.6s;
  position: sticky;
  top: 0;
  z-index: 1000;
}

/* 顶部的图标 */
#header .header-top span {
  margin: 0 8px;
}

/* 导航栏 */
#header .header-nav {
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: transparent;
}

/* 主题切换按钮 - 桌面版 */
#header .header-theme-toggle {
  margin-left: 20px;
}

/* 主题切换按钮 - 移动版 */
#header .header-nav-m-right {
  display: flex;
  align-items: center;
}

/* 导航栏透明时的样式 */
#header[style*="background: transparent"] .header-nav {
  background: transparent;
}

/* 导航栏logo */
#header .header-nav .header-nav-logo {
  height: 100%;
  display: flex;
  align-items: center;
}

/* 导航栏logo图片 */
#header .header-nav .header-nav-logo img {
  width: auto;
  height: 60px;
  transition: transform 0.3s ease;
}

#header .header-nav .header-nav-logo img:hover {
  transform: scale(1.05);
}

/* 导航栏 导航容器 */
#header .header-nav-fixed .header-nav-wrapper {
  line-height: 60px;
}

#header .header-nav .header-nav-wrapper {
  line-height: 100px;
  display: flex;
  align-items: center;
  margin: 0;
  max-width: 800px;
}

/* 导航栏 每个导航 */
#header .header-nav .header-nav-wrapper>li {
  position: relative;
  margin: 0 20px;
  transition: all 0.3s ease;
}

/* 导航栏 每个导航下面的 a 链接 */
#header .header-nav .header-nav-wrapper>li>a {
  color: var(--text-primary);
  font-size: 16px;
  font-weight: 500;
  padding: 10px 0;
  position: relative;
  text-decoration: none;
  transition: color 0.3s ease;
}



/* 导航栏 每个导航下面的 a 链接的下划线 */
#header .header-nav .header-nav-wrapper>li>a>i {
  display: block;
  position: absolute;
  bottom: -2px;
  left: 50%;
  width: 0;
  height: 3px;
  opacity: 0;
  transition: all 0.4s ease;
  background-color: #10ccd2;
  border-radius: 2px;
}

/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
#header .header-nav .header-nav-wrapper>li>a>span {
  font-size: 12px;
  transition: transform ease 0.3s;
  margin-left: 4px;
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
#header .header-nav .header-nav-wrapper>li>a:hover {
  color: var(--primary-color);
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
#header .header-nav .header-nav-wrapper>li>a:hover .underline {
  opacity: 1;
  width: 100%;
  left: 0;
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
#header .header-nav .header-nav-wrapper>li>a:hover span {
  transform: rotate(180deg);
}

/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
#header .header-nav .header-nav-wrapper>li.active>a {
  color: var(--primary-color);
  text-decoration: none;
}



#header .header-nav .header-nav-wrapper>li.active>a .underline {
  opacity: 1;
  width: 100%;
  left: 0;
}

/* 导航栏 每个导航下面的二级导航容器 */
#header .header-nav .header-nav-wrapper>li>dl {
  display: none;
  position: absolute;
  width: 180px;
  top: 90%;
  left: 50%;
  transform: translateX(-50%);
  z-index: 999999;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  transition: all 0.3s ease;
}

/* 导航栏 每个导航下面的二级导航容器的每个导航 */
#header .header-nav .header-nav-wrapper>li>dl>dt {
  width: 100%;
  padding: 12px 20px;
  border-bottom: 1px solid #f0f0f0;
  transition: all 0.3s ease;
}

/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
#header .header-nav .header-nav-wrapper>li>dl>dt>a {
  color: #333;
  text-decoration: none;
  display: block;
  transition: color 0.3s ease;
}

#header .header-nav .header-nav-wrapper>li>dl>dt>a:hover {
  color: #10ccd2;
}

/* 导航栏 滑上一级导航显示二级导航 */
#header .header-nav .header-nav-wrapper>li:hover dl {
  display: block;
  animation: dropdown 0.3s ease;
}

@keyframes dropdown {
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
}

#header .header-nav .header-nav-wrapper>li>dl>dt:hover {
  cursor: pointer;
  background: #f8f9fa;
}

/* 移动端导航 */
#header .header-nav-m {
  position: relative;
  background: var(--bg-primary);
  box-shadow: var(--shadow-sm);
}

/* 导航栏logo容器 */
#header .header-nav-m .header-nav-m-logo {
  height: 80px;
  position: relative;
  display: flex;
  align-items: center;
}

/* 导航栏logo图片 */
#header .header-nav-m .header-nav-m-logo img {
  width: auto;
  height: 45px;
  margin: 0;
  transition: transform 0.3s ease;
}

#header .header-nav-m .header-nav-m-logo img:hover {
  transform: scale(1.05);
}

/* 导航栏  菜单按钮 */
#header .header-nav-m .menu-btn {
  font-size: 24px;
  color: #333;
  cursor: pointer;
  transition: color 0.3s ease;
}

#header .header-nav-m .menu-btn:hover {
  color: #10ccd2;
}

/* 导航栏 菜单图标 */
#header .header-nav-m .header-nav-m-menu-wrapper {
  position: absolute;
  top: 50%;
  right: 20px;
  margin-top: -20px;
  width: 50px;
  height: 40px;
  color: #333;
  z-index: 999999;
  font-size: 12px;
}

/* 导航栏 */
#header .header-nav-m .header-nav-m-wrapper {
  background: var(--bg-primary);
  border-top: 1px solid var(--border-color);
  box-shadow: var(--shadow-md);
}

/* 导航栏 每个导航 */
#header .header-nav-m .header-nav-m-wrapper>li {
  height: 60px;
  line-height: 60px;
  border-bottom: 1px solid var(--border-color);
  transition: background-color 0.3s ease;
}

#header .header-nav-m .header-nav-m-wrapper>li:hover {
  background-color: var(--bg-secondary);
}

/* 导航栏 每个导航下面的 a 链接 */
#header .header-nav-m .header-nav-m-wrapper>li>a {
  color: var(--text-primary);
  font-size: 16px;
  font-weight: 500;
  padding: 0 20px;
  position: relative;
  display: block;
  transition: color 0.3s ease;
}

#header .header-nav-m .header-nav-m-wrapper>li>a:hover {
  color: var(--primary-color);
  text-decoration: none;
}

#header .header-nav-m .header-nav-m-wrapper>li.active>a {
  color: var(--primary-color);
}

/* 导航栏 每个导航下面的 a 链接的下划线 */
#header .header-nav-m .header-nav-m-wrapper>li>a>i {
  display: block;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 3px;
  transition: all 0.4s ease;
  background-color: #10ccd2;
}

#header .header-nav-m .header-nav-m-wrapper>li.active>a>i {
  width: 100%;
}

/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
#header .header-nav .header-nav-wrapper>li>a>span {
  font-size: 10px;
}

/* 响应式设计 */
@media screen and (min-width: 768px) and (max-width: 996px) {
  #header .header-nav {
    height: 90px;
  }
  
  #header .header-nav .header-nav-logo img {
    width: auto;
    height: 50px;
  }
  
  #header .header-nav .header-nav-wrapper>li {
    margin: 0 12px;
  }
  
  #header .header-nav .header-nav-wrapper>li>a {
    font-size: 15px;
  }
}

@media screen and (max-width: 767px) {
  #header .header-nav {
    height: 80px;
  }
  
  #header .header-nav .header-nav-logo img {
    height: 45px;
  }
  
  #header .header-nav-m .header-nav-m-logo {
    height: 70px;
  }
  
  #header .header-nav-m .header-nav-m-logo img {
    height: 40px;
  }
  
  #header .header-nav-m .header-nav-m-wrapper>li {
    height: 55px;
    line-height: 55px;
  }
  
  #header .header-nav-m .header-nav-m-wrapper>li>a {
    font-size: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue